export const getCookieExpirationByYears = (years) => new Date(
    Date.now() + years * 365 * 24 * 60 * 60 * 1000
);
